<!--
 * @Author: 常培
 * @Date: 2020-04-02 11:10:31
 * @LastEditTime: 2020-04-02 11:10:31
 * @Description: Edit.vue
 -->
<template>
  <LayoutAuto class="layout-auto">
    <div v-if="sponsorUpdated" class="header">
      <div class="title">
        <span class="name">
          {{formInfo.approvalName}}
          <el-popover v-if="formInfo.helpInfo" :disabled="true" placement="bottom" width="380" trigger="hover">
            <p v-html="formInfo.helpInfo"></p>
            <i class="iconfont iconquestion-circle" slot="reference" @click="setIsShowHelpInfo(true)"></i>
          </el-popover>
        </span>
      </div>
      <div>
        <el-button @click="openSaveDialog">存储模版</el-button>
        <el-button @click="opentSelectDialog">调用模版</el-button>
        <el-button @click="opentManageDialog">管理模版</el-button>
      </div>
    </div>
    <!-- 表单发起 -->
    <Sponsor @hook:updated="handleSponsorUpdated" ref="sponsor" :approvalInfo="formInfo" class="sponsor" />
    <div v-if="sponsorUpdated" class="handle">
        <el-button @click="saveDraft" :disabled="saveLoading">保存草稿</el-button>
        <el-button type="primary" @click="formSubmit" :disabled="submitLoading">提交</el-button>
    </div>
    
    <SaveTmpDialog 
      :visible.sync="saveDialogVisible"
      @save="saveTemplate" 
    />
    <SelectTmpDialog 
      :visible.sync="selectDialogVisible"
      :templateList="templateList" 
      @confirm="getTemplateDetail"
    />
    <ManageTmpDialog 
      :visible.sync="manageDialogVisible"
      :templateList="templateList"
      @deleteTemplate="deleteTemplate"
    />
  </LayoutAuto>
</template>

<script>
import Sponsor from '../../components/Sponsor'
import { mapMutations, mapState } from 'vuex';
import { loadingConfig } from '@/utils/commonConfig';
import ManageTmpDialog from './components/ManageTmpDialog';
import SaveTmpDialog from './components/SaveTmpDialog';
import SelectTmpDialog from './components/SelectTmpDialog'

export default {
  data() {
    return {
      formInfo: {},
      saveDialogVisible: false,
      selectDialogVisible: false,
      manageDialogVisible: false,
      templateList: [],
      sponsorUpdated: false,
      submitLoading: false,
      saveLoading: false
    }
  },
  computed: {
    ...mapState('base', {
      userInfo: 'userInfo'
    }),
    ...mapState('form', {
      formError: 'formError',
    }),
  },
  created() {
    this.getFormInfo()
  },
  mounted() {
  },
  methods: {
    ...mapMutations('base', {
      setIsShowHelpInfo: 'setIsShowHelpInfo'
    }),
    getFormInfo() {
      const loading = this.$loading(loadingConfig)
      const { 
        approvalId = '', 
        tabType = 6,
        isBringUp = 0
      } = this.$route.query
      let apiName = 'getBringUpInfo' 
      let params = { approvalId };
      if (isBringUp != 1) { // isBringUp === 1 为复制重发
        Object.assign(params, {
          tabType, // tabType 5 我的草稿；6 发起审批；
          processWebFormId: this.$route.params.processWebFormId,
        });
        apiName = 'getInfo'
      }
      _api.approval[apiName](params).then(data => {
        this.formInfo = data
      }).finally(() => {
        loading.close()
      })
    },
    openSaveDialog() {
      this.saveDialogVisible = true;
    },
    opentSelectDialog() {
      this.getTemplateList().then(() => {
        this.selectDialogVisible = true
      })
    },
    opentManageDialog() {
      this.getTemplateList().then(() => {
        this.manageDialogVisible = true
      })
    },
    saveTemplate(title) {
      const templateData = this.$refs.sponsor.getApprovalData();
      _api.sponsor.saveTemplate({
        title,
        templateData,
        processWebFormId: this.formInfo.processWebFormId,
        forminfoId: this.formInfo.forminfoId,
        formType: this.formInfo.formType
      }).then(data => {
        if (data) this.$message.success('模版保存成功!')
      })
    },
    getTemplateDetail(id) {
      const loading = this.$loading(loadingConfig)
      _api.sponsor.getTemplateDetail({ id }).then(data => {
        this.formInfo = data
      }).finally(() => {
        loading.close()
      })
    },
    deleteTemplate(id) {
      _api.sponsor.deleteTemplate({ id }).then(data => {
        this.getTemplateList();
        this.$message.success('模版删除成功!')
      })
    },
    getTemplateList() {
      return _api.sponsor.getTemplateList({
        processWebFormId: this.formInfo.processWebFormId,
        forminfoId: this.formInfo.forminfoId,
        formType: this.formInfo.formType
      }).then(data => {
        this.templateList = data
      })
    },
    handleSponsorUpdated() {
      this.sponsorUpdated = true
    },
    saveDraft() {
      if (this.formError) {
        this.$message.error(this.formError);
        return
      }
      this.saveLoading = true
      _api.sponsor.sponsorSaveDraft(this.getParams()).then(data => {
        this.$message.success('保存草稿成功');
        this.goDraft(); 
      }).finally(() => {
        this.saveLoading = false;
      })
    },

    formSubmit() {
      if (this.formError) {
        this.$message.error(this.formError);
        return
      }
      if (!this.$refs.sponsor.validateForm()) return

      this.submitLoading = true;
      _api.sponsor.sponsorSubmit(this.getParams()).then(data => {
        this.$message.success('提交成功');
        this.goSend();      
      }).finally(() => {
        this.submitLoading = false;
      })
    },
    scrollToError({anchorId, groupName}) {
      const DOM = document.querySelector(anchorId);
      setTimeout(() => {
        DOM.scrollIntoView({behavior: 'smooth'})
        if (groupName) this.$message.error(`请完善${groupName}!`)
      }, 150)
    },
    goSend() {
      this.$router.push('/approval/send')
    },
    goDraft() {
      this.$router.push('/approval/draft')
    },
    getParams() {
      const {
        approvalId,
        approvalName,
        processWebFormId,
        formType,
        forminfoId,
      } = this.formInfo;
      const {email, emailPrefix: applyUsercode} = this.userInfo;
      const approvalData = this.$refs.sponsor.getApprovalData();
      const params = {
        approvalName,
        processWebFormId,
        formType,
        forminfoId,
        email,
        applyUsercode,
        approvalData,
        approvalId
      }
      if (this.$route.query?.isBringUp == 1) {
        Object.assign(params, {
          beBringUpApprovalId: approvalId,
          approvalId: null
        })
      } 
      return params
    }
  },
  components: {
    Sponsor,
    ManageTmpDialog,
    SaveTmpDialog,
    SelectTmpDialog,
  }
}
</script>

<style scoped lang="scss">
.layout-auto {
  width: $mainContentWidth;
  padding: 0 0;
}

.header{
  display: flex;
  align-items: center;
  .title{
    flex: 1;
    border-bottom: #EBEEF5 1px solid;
    margin: 20px 20px 0 0px;
    height: 38px;
    line-height: 20px;
    display: flex;
    .bar-code{
      padding-left: 20px;
      margin-top: -3px;
      flex: 1;
    }
    .name{
      font-size: 18px;
      color: #303133;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .iconquestion-circle{
        font-size: 16px;
        color: #cd2e23;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
    }
  }
}
.sponsor {
  margin-bottom: 50px;
}
.white-wrap{
  margin-bottom: 30px;
}
.handle{
  position: fixed;
  background: #fff;
  bottom: 0;
  z-index: 10;
  text-align: right;
  width: $mainContentWidth;
  // width: inherit;
  padding: 10px 10px 10px 0;
  &::before{
    content: '';
    position: fixed;
    width: 100%;
    height: 56px;
    background: #fff;
    z-index: -1;
    left: 0;
    bottom: 0;
    box-shadow: 0 0px 6px 2px #e6e7e8;
  }
}


</style>

